import Field from "@hudson/ui/components/FormFields/Field";
import Input from "@hudson/ui/components/FormFields/Input";
import creditCardType from "credit-card-type";
import CreditCardIcon from "../CreditCardIcon";

function luhn(value: string) {
  // Accept only digits, dashes or spaces
  if (/[^0-9-\s]+/.test(value)) return false;
  if (!/[^0-\s]+/.test(value)) return false; // All zeros

  // The Luhn Algorithm. It's so pretty.
  let nCheck = 0,
    bEven = false;
  value = value.replace(/\D/g, "");
  if (value.length < 12) return false;

  for (var n = value.length - 1; n >= 0; n--) {
    var cDigit = value.charAt(n),
      nDigit = parseInt(cDigit, 10);
    if (bEven && (nDigit *= 2) > 9) nDigit -= 9;
    nCheck += nDigit;
    bEven = !bEven;
  }
  return nCheck % 10 == 0;
}

function formatCreditCard(value: string): string {
  const digitsOnly = value.replace(/\D/g, "");
  // Amex: 4-6-5 format, others: 4-4-4-4(-3) format
  if (/^3[47]/.test(digitsOnly)) {
    // American Express
    return digitsOnly.replace(/(\d{4})(\d{6})(\d{0,5})/, "$1 $2 $3").trim();
  } else {
    // Visa, Mastercard, Discover, etc.
    return digitsOnly.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
  }
}

function Number({
  className = "",
  errorMessage,
  errorInvalid,
  errorType,
  fieldName,
  label,
  invalidTypes,
  requiredPlaceholder,
}: {
  className?: string;
  errorMessage: string;
  errorInvalid: string;
  errorType: string;
  fieldName: string;
  label: string;
  invalidTypes: string[];
  requiredPlaceholder?: string;
}): JSX.Element | null {
  return (
    <Field
      className={className}
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <div className="flex gap-x-4">
          <Input
            autoComplete="cc-number"
            className="w-60"
            inError={inError}
            onBlur={() => {
              // Format the value on blur
              const formatted = formatCreditCard(String(value));
              if (formatted !== value) {
                onChange(formatted);
              }
              onBlur();
            }}
            onChange={onChange}
            required={Boolean(errorMessage)}
            requiredPlaceholder={requiredPlaceholder}
            value={value ? String(value) : ""}
          />
          <CreditCardIcon number={String(value)} />
        </div>
      )}
      fieldName={fieldName}
      fieldValidations={{
        required: errorMessage,
        validate: {
          validNum: (v) => !v || luhn(v) || errorInvalid,
          validType: (v) =>
            !(creditCardType(v)[0]?.type == "american-express" && invalidTypes.includes("amex")) ||
            errorType,
        },
      }}
      label={label}
    />
  );
}

export default Number;
